import React from 'react';
import Icon from '../../../components/AppIcon';

const TrustSignals = () => {
  const trustFeatures = [
    {
      icon: 'Shield',
      title: 'SSL Encrypted',
      description: 'Your data is protected with 256-bit SSL encryption'
    },
    {
      icon: 'Lock',
      title: 'Secure Login',
      description: 'Multi-factor authentication available'
    },
    {
      icon: 'Database',
      title: 'Data Backup',
      description: 'Automatic daily backups ensure data safety'
    },
    {
      icon: 'Eye',
      title: 'Privacy Protected',
      description: 'We never share your business information'
    }
  ];

  return (
    <div className="w-full max-w-4xl mx-auto mt-12">
      <div className="text-center mb-8">
        <h2 className="text-xl font-semibold text-foreground mb-2">Your Business Data is Secure</h2>
        <p className="text-muted-foreground">Enterprise-grade security for your inventory management</p>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
        {trustFeatures?.map((feature, index) => (
          <div key={index} className="bg-card border border-border rounded-lg p-6 text-center hover:shadow-card transition-hover">
            <div className="w-12 h-12 bg-success/10 rounded-lg flex items-center justify-center mx-auto mb-4">
              <Icon name={feature?.icon} size={24} className="text-success" />
            </div>
            <h3 className="text-sm font-medium text-foreground mb-2">{feature?.title}</h3>
            <p className="text-xs text-muted-foreground leading-relaxed">{feature?.description}</p>
          </div>
        ))}
      </div>
      {/* Security Badges */}
      <div className="flex items-center justify-center space-x-8 mt-8 pt-8 border-t border-border">
        <div className="flex items-center space-x-2">
          <Icon name="ShieldCheck" size={20} className="text-success" />
          <span className="text-sm text-muted-foreground">SOC 2 Compliant</span>
        </div>
        <div className="flex items-center space-x-2">
          <Icon name="Award" size={20} className="text-success" />
          <span className="text-sm text-muted-foreground">ISO 27001 Certified</span>
        </div>
        <div className="flex items-center space-x-2">
          <Icon name="Zap" size={20} className="text-success" />
          <span className="text-sm text-muted-foreground">99.9% Uptime</span>
        </div>
      </div>
    </div>
  );
};

export default TrustSignals;